import { useContext } from "react";
import { useLocation } from "react-router-dom";
import AroundCircle from "src/components/AroundCircle/AroundCircle";
import Page from "src/components/Report/Page";
import jobContext from "src/context/jobContext";

export default function Page6() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    const { job } = useContext(jobContext);

    let shayestegihayeTakhasosi = {};
    const localData = JSON.parse(localStorage?.data || "{}");
    if (localData?.[jobId]?.shayestegihayeTakhasosi) {
        shayestegihayeTakhasosi = localData[jobId].shayestegihayeTakhasosi;
    }

    console.log("shayestegihayeTakhasosi", shayestegihayeTakhasosi);

    // -------------------------
    // استخراج داده‌های دور دایره (01 ها)
    // -------------------------
    const dataArray = Object.entries(shayestegihayeTakhasosi)
        .filter(([key]) => key.slice(-2)[1] === "1")
        .map(([key, value]) => value);

    // -------------------------
    // گروه‌بندی داده‌ها بر اساس رقم دهگان
    // -------------------------
    const groups = {};
    Object.entries(shayestegihayeTakhasosi).forEach(([key, value]) => {
        const idx = key.slice(-2); // مثل 03
        const tens = idx[0];       // مثل 0 → گروه 0

        if (!groups[tens]) groups[tens] = {};
        groups[tens][idx] = value;
    });

    // -------------------------
    // ساخت ردیف‌ها (Grid 5 ستونه)
    // -------------------------
    const div = Object.keys(groups)
        .sort()
        .map((groupKey) => {
            const group = groups[groupKey];
            const indexes = Object.keys(group).sort(); // فقط ستون‌هایی که داده دارند

            return (
                <div
                    key={groupKey}
                    className="grid grid-cols-5 gap-0 w-full"
                >
                    {indexes.map((idx) => (
                        <div
                            key={idx}
                            className="border border-gray-300 p-2 rounded-sm text-xs flex items-start justify-start"
                        >
                            {group[idx]}
                        </div>
                    ))}

                    {/* اگر کمتر از 5 ستون داشت، خانه‌های خالی بساز */}
                    {Array.from({ length: 5 - indexes.length }).map((_, i) => (
                        <div
                            key={`empty-${i}`}
                            className="border border-gray-300 p-2 rounded-sm"
                        ></div>
                    ))}
                </div>
            );
        });

    return (
        <Page pageNumber={15}>
            <div className="font-bold text-lg">
                مدل شایستگی تخصصی {job.title}
            </div>

            <div className="flex gap-5 justify-center items-center">
                <p className="text-black text-justify">
                    مدل شایستگی تخصصی مجموعه‌ای از دانش، مهارت‌ها و توانمندی‌های فنی است که برای انجام وظایف خاص شغل ضروری‌اند. این شایستگی‌ها بر اساس ماهیت حرفه، الزامات تخصصی، و فناوری‌های مرتبط تعریف می‌شوند. هدف از این مدل، ارتقاء عملکرد تخصصی، انطباق با استانداردهای حرفه‌ای، و توسعه مسیر شغلی است. درج این بخش مبنایی برای آموزش تخصصی، ارزیابی فنی و انتخاب افراد واجد شرایط فراهم می‌سازد.
                </p>

                <div className="flex flex-col ml-20 my-0 scale-90">
                    <AroundCircle
                        title={`شایستگی تخصصی ${job.title}`}
                        dataArray={dataArray}
                    />
                </div>
            </div>

            <div className="flex flex-col justify-between mt-32">

                {/* هدر ستون‌ها */}
                <div className="bg-blue-600 grid grid-cols-5 w-full text-white p-3 py-2 rounded-sm text-center">
                    <div>عنوان شایستگی</div>
                    <div>شرح شایستگی</div>
                    <div>مولفه‌های شایستگی</div>
                    <div>برنامه توسعه</div>
                    <div>آزمون/ابزار</div>
                </div>

                {/* ردیف‌های داینامیک */}
                <div className="flex flex-col gap-0 w-full rounded-md">
                    {div}
                </div>

            </div>
        </Page>
    );
}
